"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Philosophy() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="philosophy-statement" data-nav="light" className="relative bg-background text-foreground py-20 sm:py-24 md:py-32 overflow-hidden border-y border-border/40">
      {/* Subtle architectural background watermarks */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-25">
        <div className="w-[480px] h-[480px] sm:w-[620px] sm:h-[620px] rounded-full border border-border/60" />
        <div className="absolute w-[320px] h-[320px] sm:w-[420px] sm:h-[420px] rounded-full border border-border/40" />
      </div>

      <div className="relative mx-auto max-w-4xl px-6 sm:px-8 text-center">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center">
          {/* Eyebrow marker */}
          <span className="font-sans text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-8 sm:mb-10">
            Our Guiding Philosophy
          </span>

          {/* Top Sterling Editorial Rule with Centered Diamond */}
          <div className="w-full flex items-center justify-center gap-4 mb-8 sm:mb-12">
            <div className="h-px flex-1 bg-border/60 max-w-[140px] sm:max-w-[200px]" />
            <div className="w-2 h-2 rotate-45 border border-primary/60 bg-background shrink-0" />
            <div className="h-px flex-1 bg-border/60 max-w-[140px] sm:max-w-[200px]" />
          </div>

          {/* Verbatim Core Philosophy Quote */}
          <blockquote className="my-2 sm:my-4">
            <p className="font-serif italic font-normal text-foreground text-xl sm:text-2xl md:text-3xl lg:text-[2.15rem] leading-relaxed md:leading-[1.45] tracking-tight">
              &ldquo;We understand that orchestrating travel for multiple generations requires more than just booking accommodations; it requires empathetic understanding and a philosophical approach to cultural movement and shared experiences.&rdquo;
            </p>
          </blockquote>

          {/* Bottom Sterling Editorial Rule with Centered Diamond */}
          <div className="w-full flex items-center justify-center gap-4 mt-8 sm:mt-12 mb-6">
            <div className="h-px flex-1 bg-border/60 max-w-[140px] sm:max-w-[200px]" />
            <div className="w-2 h-2 rotate-45 border border-primary/60 bg-background shrink-0" />
            <div className="h-px flex-1 bg-border/60 max-w-[140px] sm:max-w-[200px]" />
          </div>

          {/* Studio attribution footer */}
          <div className="flex flex-col items-center space-y-1">
            <span className="font-sans text-xs sm:text-sm font-medium tracking-widest uppercase text-foreground">
              E•Leete Travel Design Studio
            </span>
            <span className="font-sans text-xs text-muted-foreground tracking-wider">
              Anchor &amp; Orbit™ Methodology
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}